import {
  AppIdvAcceptableDocumentsResponseSchema,
  GetCountrySpecificAcceptableIdDocumentsResponse,
} from "@amzn/client-workbench-api-model";
import { API } from "@aws-amplify/api";

import { API_METRICS_HANDLE } from "@/apis/constants";
import { Logger } from "@/apis/Logger";
import {
  publishQueryLatencyMetrics,
  publishQueryResultMetrics,
} from "@/apis/Metrics";

import { AMPLIFY_DEFAULT_API_NAME } from "../amplifyConfig";

export const GET_IDV_DOCUMENTS_METRIC_NAME = "IdvAcceptableDocuments";
export const GET_IDV_DOCUMENTS_PATH = "/app/idvAcceptableDocuments";

/**
 * Fetch country-specific IDV acceptable documents from API and submit latency metrics.
 */
export const fetchIdvAcceptableDocuments =
  async (): Promise<AppIdvAcceptableDocumentsResponseSchema> => {
    const startTime = performance.now();
    try {
      const response = (await API.get(
        AMPLIFY_DEFAULT_API_NAME,
        GET_IDV_DOCUMENTS_PATH,
        {}
      )) as GetCountrySpecificAcceptableIdDocumentsResponse;

      publishQueryResultMetrics({
        queryFunctionName: GET_IDV_DOCUMENTS_METRIC_NAME,
        metricsPublisherHandler: API_METRICS_HANDLE,
        numSuccess: 1,
        numFailures: 0,
      });

      return response;
    } catch (err) {
      void Logger.errorErrorLike(
        `${GET_IDV_DOCUMENTS_METRIC_NAME} failed API call.`,
        err
      );
      publishQueryResultMetrics({
        queryFunctionName: GET_IDV_DOCUMENTS_METRIC_NAME,
        metricsPublisherHandler: API_METRICS_HANDLE,
        numSuccess: 0,
        numFailures: 1,
      });
      return Promise.reject(err);
    } finally {
      publishQueryLatencyMetrics({
        metricsPublisherHandler: API_METRICS_HANDLE,
        queryFunctionName: GET_IDV_DOCUMENTS_METRIC_NAME,
        elapsedTime: performance.now() - startTime,
      });
    }
  };
